import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EnvironmentService } from '@app/core/environment/environment.service';
import { environment } from '@env/environment';
import { ErrorService } from '@app/core/error/error.service';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';

export abstract class AbstractServiceWithoutToken {

  public baseBackUrl: string;

  public datePipe = new DatePipe(navigator.language);

  constructor(
    public environmentService: EnvironmentService,
    public router: Router,
    public errorService?: ErrorService,
    public activeModal?: NgbActiveModal
  ) {
    if (this.environmentService === undefined ||
        this.environmentService.finalEnvironment === undefined ||
        this.environmentService.finalEnvironment === null) {
      this.baseBackUrl = environment.baseBackUrl;
    } else {
      this.baseBackUrl = this.environmentService.finalEnvironment.baseBackUrl;
    }
  }

  // Handle API errors
  public handleError(error: HttpErrorResponse, isShowError: boolean = true, errorMessage?: string): Observable<never> {
    let causes: Array<string> = [];
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
    console.error(
      'Backend error: ' +
      `Status code ${error.status}, ` +
      `Status text ${error.statusText}, ` +
      `Name ${error.name}, ` +
      `Message: ${error.message}`);
    if (error.error) {
      console.error(
        'Cronoss error: ' +
        `Status code ${error.error.status as string}, ` +
        `Status reason ${error.error.statusReason as string}, ` +
        `Error code ${error.error.code as string}, ` +
        `Message: ${error.error.message as string}`);
    }

    if (!this.checkSecurityError(error)) {
      if (error.error) {
        if (error.error.code) {
          causes = [error.error.code];
        } else {
          if (error.status === 0) {
            causes = ['common.system.is.unavailable'];
          } else {
            const errorAux = 'Backend error: ' +
            `Status code ${error.status}, ` +
            `Status text ${error.statusText}, ` +
            `Name ${error.name}, ` +
            `Message: ${error.message}`;
            causes = ['common.errors.generic', errorAux];
          }
        }
      } else {
        if (error.name && error.message === 'Timeout has occurred') {
          causes = ['common.errors.timeout'];
        }
      }
      if (isShowError) {
        if (errorMessage === undefined || errorMessage === null) {
          errorMessage = 'common.system.is.unavailable';
        }
        void this.errorService.showError(errorMessage, causes);
      }
    }

    // return an observable with a user-facing error message
    return throwError(error);
  }

  getApiDateStringFromDate(date: Date): string {
    if (date) {
      return this.datePipe.transform(date, environment.apiDateFormat);
    } else {
      return '';
    }
  }

  getApiDateTimeStringFromDate(date: Date): string {
    if (date) {
      return this.datePipe.transform(date, environment.apiDateFormat + ' ' + environment.apiTimeFormat);
    } else {
      return '';
    }
  }

  getDateTimeStringFromDate(date: string): string {
    if (date) {
      return this.datePipe.transform(date, environment.dateFormat + ' ' + environment.timeFormat);
    } else {
      return '';
    }
  }

  private checkSecurityError(error: HttpErrorResponse): boolean {

    let isSecurityError = false;

    if (error.error !== undefined && error.error !== null) {
      if (error.error.status !== undefined && error.error.status !== null) {
        if (error.error.status === 401 || error.error.status === 403) {
          isSecurityError = true;
        }
      }
      if (error.status !== undefined && error.status !== null) {
        if (error.error.status === 401 || error.error.status === 403) {
          isSecurityError = true;
        }
      }
    }

    if (isSecurityError) {
      if (error.url.search('signin') === -1) {
        if (environment.security) {
          void this.router.navigate(['login']);
          if (this.activeModal !== undefined && this.activeModal !== null) {
            this.activeModal.close();
          }
        }
        const errorMessage = 'common.auth.unauthorized';
        const causes = ['common.auth.token.timeout', 'common.auth.permission.denied'];
        void this.errorService.showError(errorMessage, causes);
      }
    }

    return isSecurityError;

  }

}
